import React, { useEffect, useState } from "react";
import { dnbComLog, isNotUndefinedOrNull, LogSeverity } from '@/shared/FunctionCore';
import { allowedDomains } from "@/shared/constant";
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || undefined;
const recaptchaJavascriptPath = `https://www.google.com/recaptcha/enterprise.js?render=${recaptchaSiteKey}`;

const removeReCaptchaDiv = () => {
  const recaptchaDiv = document.querySelector('.grecaptcha-badge');
  if (recaptchaDiv) {
    recaptchaDiv.parentNode?.removeChild(recaptchaDiv);
  }
}

const GoogleRecaptcha = ({ action }): JSX.Element => {
  useEffect(() => {
    const currentDomain = window.location.hostname;
    if (!allowedDomains.includes(currentDomain)) {
      dnbComLog(LogSeverity.ERROR, `reCAPTCHA blocked: Invalid domain ${currentDomain}`);
      return;
    }
    if (recaptchaSiteKey && isNotUndefinedOrNull(recaptchaSiteKey)) {
      const scriptId = "recaptcha-script";
      const htmlScriptElement = window.document.createElement("script");
      htmlScriptElement.src = recaptchaJavascriptPath;
      htmlScriptElement.id = scriptId;
      window.document.head.append(htmlScriptElement);
      htmlScriptElement.addEventListener("load", () => {
        try {
          const windowGrecaptcha = window["grecaptcha"];
          const windowGrecaptchaEnterprise = windowGrecaptcha["enterprise"];
          windowGrecaptchaEnterprise.ready(() => {
            windowGrecaptchaEnterprise
              .execute(recaptchaSiteKey, {
                action: action,
              })
              .then((_token) => {
                let token = _token;
              });
          });
        } catch {
          console.log('Failed to load Google Recaptcha');
        }
      });

      return () => {
        // Remove recaptcha badge on unmount
        removeReCaptchaDiv();
      };
    } else {
      console.log('Recaptcha value is not set in env Props file');
    }
  }, [action]);

  return <></>;
};

export default GoogleRecaptcha;